export enum NotificationType {
  "Oferta" = "Oferta",
  "Informativo" = "Informativo",
  "Receita" = "Receita",
  "Combustivel" = "Combustivel",
  "Custom" = "Custom",
}
